// Libraries
import React, { useEffect, useState } from "react";

// Import router from next
import { useNavigate } from "react-router-dom";
import InputBase from "@mui/material/InputBase";
import { styled } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import Avatar from "@mui/material/Avatar";
import MenuList from '@mui/material/MenuList';
import Divider from '@mui/material/Divider';
import { Buffer } from "buffer";
import moment from "moment";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import mixpanel from 'mixpanel-browser';
import Button from '../button/button';
import BoardIconWhite from '../../asstes/boardicon.svg';
import BoardIconBlack from '../../asstes/boardIconBlack.svg';
import SettingIconWhite from '../../asstes/settingicon.svg';
import SettingIconBlack from '../../asstes/settingiconBlack.svg';
import BAvatar from '../../asstes/bavatar.svg';
import ProfileAvatar from '../../asstes/profileAvatar.svg';
import Tooltip,{ TooltipProps }  from '@mui/material/Tooltip';
// Import supabase configuration
import supabase from "../../config/supabase";

// Client header
function Header({boardName, addCandidate=false }) {
    const [showTransition, setShowTransition] = useState(false);
    const [noShow, setNoShow] = useState(true);
    const [count, setCount] = useState(0);
    const [overBoards,setOverBoard] = useState(false);
    const [overCandidate,setOverCandidate] = useState(false);
    const [overProfile,setOverProfile] = useState(false)
    const navigate = useNavigate();


    const ToBeStyledTooltip = ({ className, ...props }) => (
        <Tooltip {...props} classes={{ tooltip: className }} />
    );
      
      const StyledTooltip = styled(ToBeStyledTooltip)(({ theme }) => ({
        backgroundColor: '#ffffff',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: 16,
        border: '1px solid #C4DBF6',
        borderRadius:0,
        fontWeight:500,
        fontFamily:"Poppins",
      }));
    const BootstrapInput = styled(InputBase)(({ theme }) => ({
        "& .MuiInputBase-input": {
        "&:focus": {
            borderRadius: 4,
            borderColor: "",
            boxShadow: "",
        },
        root: {
            '&:hover': {
              backgroundColor: 'transparent',
            },
          },
        },
    }));

    const controlMenuTransition = () => {
        setShowTransition(!showTransition);
        if(count == 0){
            setCount(1);
            setNoShow(!noShow);
        }
        else{
            count >=1 && setTimeout(() => {
                 showTransition && setNoShow(true);
                 setCount(0);
            }, 500);
        } 
       
    }
    const toHome = () =>{
        navigate('/');
    }
    const handleBoardClick = () =>{
        navigate("/board");
    }

    const handleAddCandidate = () =>{
        navigate("/addProspect");
    }

    const handleCandidatesButton = () =>{
        navigate("/candidates");
    }

    const handleLogOutClick = async() =>{
        const { error } = await supabase.auth.signOut();
        if (!error) {
            var candidatesDataDrafts = localStorage.getItem('candidates');
            localStorage.clear();
            localStorage.setItem('candidates',candidatesDataDrafts);
            navigate("/login");
        }
    }
  const handleMenuClickAway = (event) => {
        if(showTransition){
            setShowTransition(!showTransition);

            setTimeout(() => {
                setNoShow(true);
                setCount(0);

           }, 500);
        } 
  };
    // return
    return (
        // Render header
            <div className="h-full">

                <div className="flex sticky top-0 z-50">
                    <div className="flex justify-between shadow-clientHeader items-center relative w-full h-20 bg-white-1 px-5 box-border">
                        {/* For small screens */}
                        <div className="md:hidden">
                            {/* Add icon */}
                            <p onClick={() => toHome()}>
                                <img src="/Logo.svg" className="pl-2 cursor-pointer" />
                            </p>
                        </div>
                        {/* Make a group */}
                        <div className="hidden md:flex relative">
                            {/* Add icon */}
                            <p onClick={() => toHome()}>
                                <img src="/Gaperio2.svg" className="cursor-pointer" />
                            </p>
                            <span className={`invisible md:visible flex items-center ml-5 mt-1 ${addCandidate ? 'omd-1:hidden' : ''}`}>Supply team</span>
                        </div>
                    
                        {/* Icons */}
                        <div className="flex justify-end relative space-x-3">
                            <div>
                            {/* For small screens */}
                            <div className="relative md:hidden mt-1">
                                <Avatar alt="Candidates" src="/cd_mb.svg" className="cursor-pointer" onClick={() => handleCandidatesButton()}/>
                            </div> 
                            {/* setting icon for large screens */}
                            <div className="hidden md:flex relative mt-1.5"
                            onMouseOver={() => setOverCandidate(true)}
                            onMouseOut={() => setOverCandidate(false)}
                            >
                                <StyledTooltip title="Candidates">
                                    <Avatar alt="Candidates" src={overCandidate ? SettingIconBlack : SettingIconWhite} className="mt-0.5 cursor-pointer md:h-41 md:w-41 h-31 w-31" onClick={() => handleCandidatesButton()}/>
                                </StyledTooltip>
                            </div> 
                            </div>
                            <div>
                                {/* For small screens */}
                            <div className="relative md:hidden mt-1">
                                        <Avatar alt="board" src="/b_mb.svg" className="cursor-pointer" onClick={() => handleBoardClick()}/>
                            </div> 
                            {/* Board icon for large screens */}
                            <div className="hidden md:flex relative mt-1.5"
                            onMouseOver={() => setOverBoard(true)}
                            onMouseOut={() => setOverBoard(false)}
                            >
                                <StyledTooltip title="Boards">
                                    <Avatar alt="board" src={overBoards ? BoardIconBlack : BoardIconWhite} className="mt-0.5 cursor-pointer" onClick={() => handleBoardClick()}/>
                                </StyledTooltip>
                            </div> 
                            </div>

                            {/* Show menu */}
                            <div className={`${ showTransition ? "showHeaderTransition" : (noShow && !showTransition) ? "hidden" : "hideHeaderTransition"} bg-white-1 mt-14 text-sm shadow-clientHeaderMenu z-10`} >

                                <MenuList className="rounded"  input={<BootstrapInput />} >
                                
                                    <MenuItem value="Add prospect" onClick={handleAddCandidate}>
                                        Add prospect
                                    </MenuItem>
                                    <Divider sx={{ m: 0.4 }} />
                                    <MenuItem value="Log Out" onClick={handleLogOutClick}>
                                        Log Out
                                    </MenuItem>
                                </MenuList>
                            
                            </div>

                            {/* Logout */}
                            <ClickAwayListener onClickAway={(e) => handleMenuClickAway(e)}>
                                <div>
                                     {/* For small screens */}
                                     <div className="relative md:hidden mt-1">
                                        <Avatar alt="Profile" src="/fm2_mb.svg" className="cursor-pointer" onClick={() => controlMenuTransition()}/>
                                    </div> 
                                    {/* For large screens */}
                                <div className="hidden md:flex relative mt-1.5" 
                                onMouseOver={() => setOverProfile(true)}
                                onMouseOut={() => setOverProfile(false)}
                                >
                                <StyledTooltip title="Profile">
                                    <Avatar alt="Profile" src={overProfile ? ProfileAvatar : BAvatar} className="mt-0.5 cursor-pointer" onClick={() => controlMenuTransition()}/>
                                </StyledTooltip>
                                </div> 
                                </div> 
                            </ ClickAwayListener >
  
                        </div>
                    </div>
                </div>

            </div>
    );
}
// Export the Component
export default Header;